import axios from 'axios'
import website from '@/const/website'

axios.defaults.baseURL = website.url
axios.defaults.timeout = 30000

axios.interceptors.request.use(config => {

    // console.log("请求拦截器 ==>", config);
    if (config.method == 'post') {
        // console.log('这是还需要处理post请求的数据 ');
    }
    return config
})

// 接收拦截器（服务器返回回来的数据 给到前端前会触发，在里面执行业务代码）
axios.interceptors.response.use((response) => {
    const res = response
    // console.log("接收拦截器 ==>", response);
    return res
})

export default axios


// WEBPACK FOOTER //
// ./src/router/axios.js